var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',[_vm._v("Получить микрозаем может любой гражданин РФ от 18 до 70 лет, который проживает в зоне обслуживания нашей компании. Необходимо наличие стабильного источника дохода, из документов нужен только паспорт.")])])
}]

export { render, staticRenderFns }